import { useEffect, useState, useRef, useContext } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Lottie from 'lottie-react';
import LoginLottie from "../../assets/Lottie/location_permission.json";
import NotificationError from "../../assets/Icon/NotificationError.svg";
import MapPin from "../../assets/Icon/image2.svg";
import TrafficLight from "../../assets/Icon/image3.svg";
import PageLoader from '../PageLoader';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import ImageLoad from '../ImageLoad';
import { useNavigate } from 'react-router-dom';
import OneSignal from 'react-onesignal';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const features = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
    title: "Fast Pickup",
    desc: "Average wait time under 5 minutes in all major cities.",
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22.7501C11.92 22.7501 11.8399 22.7371 11.7629 22.7111C10.1739 22.1811 2.25 19.1221 2.25 10.8881V5.00012C2.25 4.64312 2.50203 4.33401 2.85303 4.26501C7.73303 3.28901 9.46305 2.43111 11.6541 1.34411C11.8651 1.23911 12.145 1.22519 12.356 1.33019C14.517 2.41919 16.2239 3.28001 21.1479 4.26501C21.4989 4.33501 21.751 4.64312 21.751 5.00012V10.889C21.751 19.123 13.827 22.182 12.238 22.712C12.16 22.737 12.08 22.7501 12 22.7501ZM3.75 5.61218V10.8881C3.75 17.7531 10.168 20.5482 12 21.2052C13.832 20.5482 20.25 17.7521 20.25 10.8881V5.61218C15.829 4.68718 13.9699 3.81901 12.0149 2.83801C9.93789 3.86501 8.135 4.69618 3.75 5.61218ZM11.542 14.5301L15.542 10.5301C15.835 10.2371 15.835 9.76211 15.542 9.46911C15.249 9.17611 14.774 9.17611 14.481 9.46911L11.011 12.9391L9.54102 11.4691C9.24802 11.1761 8.77298 11.1761 8.47998 11.4691C8.18698 11.7621 8.18698 12.2371 8.47998 12.5301L10.48 14.5301C10.626 14.6761 10.818 14.7501 11.01 14.7501C11.202 14.7501 11.396 14.6771 11.542 14.5301Z" fill="currentColor" />
      </svg>
    ),
    title: "Safe Rides",
    desc: "Background checked drivers and SOS features for safety.",
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0z" />
      </svg>
    ),
    title: "24/7 Support",
    desc: "Our dedicated team is always here to help you anywhere.",
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.75 0C4.822 0 0 4.822 0 10.75C0 16.678 4.822 21.5 10.75 21.5C16.678 21.5 21.5 16.678 21.5 10.75C21.5 4.822 16.678 0 10.75 0ZM10.75 20C5.649 20 1.5 15.851 1.5 10.75C1.5 5.649 5.649 1.5 10.75 1.5C15.851 1.5 20 5.649 20 10.75C20 15.851 15.851 20 10.75 20ZM11.736 10.222L10.128 9.823C9.87999 9.761 9.66901 9.62195 9.51001 9.41895C9.36001 9.22895 9.27701 8.98501 9.27701 8.73401C9.27701 8.11501 9.77999 7.61206 10.399 7.61206H11.099C11.671 7.61206 12.15 8.04206 12.215 8.61206C12.261 9.02406 12.628 9.32205 13.044 9.27405C13.456 9.22805 13.752 8.85695 13.706 8.44495C13.571 7.24295 12.641 6.31597 11.477 6.14697V5.75C11.477 5.336 11.141 5 10.727 5C10.313 5 9.97699 5.336 9.97699 5.75V6.15405C8.73199 6.35805 7.77701 7.43203 7.77701 8.73303C7.77701 9.32003 7.97401 9.89404 8.32901 10.342C8.68501 10.801 9.193 11.133 9.763 11.277L11.371 11.676C11.872 11.803 12.222 12.251 12.222 12.765C12.222 13.063 12.105 13.344 11.892 13.557C11.679 13.77 11.398 13.887 11.1 13.887H10.4C9.82799 13.887 9.349 13.457 9.284 12.887C9.238 12.475 8.86199 12.175 8.45499 12.225C8.04299 12.271 7.747 12.642 7.793 13.054C7.926 14.241 8.83399 15.162 9.97699 15.347V15.75C9.97699 16.164 10.313 16.5 10.727 16.5C11.141 16.5 11.477 16.164 11.477 15.75V15.3521C12.032 15.2711 12.547 15.025 12.952 14.62C13.448 14.124 13.722 13.466 13.722 12.767C13.722 11.564 12.907 10.519 11.736 10.222Z" fill="currentColor" />
      </svg>
    ),
    title: "Best Prices",
    desc: "Optimized routes and fair pricing compared to others.",
  },
];

const howItWorks = [
  {
    step: "01",
    title: "Set Your Pickup",
    desc: "Enter your pickup location and destination. Our system instantly finds nearby drivers.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
  },
  {
    step: "02",
    title: "Get Matched",
    desc: "A verified, top-rated driver is assigned to your ride within seconds.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <polyline points="16 11 18 13 22 9" />
      </svg>
    ),
  },
  {
    step: "03",
    title: "Track Live",
    desc: "Watch your driver on a live map. Share ETA with friends or family.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="3 11 22 2 13 21 11 13 3 11" />
      </svg>
    ),
  },
  {
    step: "04",
    title: "Arrive & Pay",
    desc: "Pay via UPI, card, or cash. Rate your driver and get a receipt.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
        <line x1="1" y1="10" x2="23" y2="10" />
      </svg>
    ),
  },
];

const Home = () => {

  const { t } = useTranslation();
  const { BaseUrl, handleCallApi, setShowToast, setToastMsg, loading, services, siteTitle } = useContext(MyContext);

  const [locationModel, setLocationModel] = useState(false);
  const [notificationerror, setNotificationError] = useState(false);
  const [type, setType] = useState("");
  const [pickupLocation, setPickupLocation] = useState("");
  const [dropLocation, setDropLocation] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [apiLoading, setApiloading] = useState("");
  const [navigateData, setNavigateData] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [recentUpdateTrigger, setRecentUpdateTrigger] = useState(0);

  const initialized = useRef(false);
  const navigate = useNavigate();

  const searchText = type === "Pickup" ? pickupLocation : dropLocation;

  const Bgcolors = [
    { bg: "bg-[#f2df0d1a] hover:bg-[#f2df0d33]", text: "text-[#f2df0d]" },
    { bg: "bg-[#ecfdf5] hover:bg-[#d1fae5]", text: "text-[#10b981]" },
    { bg: "bg-[#f0f9ff] hover:bg-[#e0f2fe]", text: "text-[#0ea5e9]" },
    { bg: "bg-[#fff7ed] hover:bg-[#ffedd5]", text: "text-[#f97316]" },
    { bg: "bg-[#9c27b012] hover:bg-[#9c27b042]", text: "text-[#9C27B0]" },
    { bg: "bg-[#0de7f21a] hover:bg-[#00bcd433]", text: "text-[#00BCD4]" },
  ];

  useEffect(() => {

    const fetchLocation = async () => {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
        () => {},
        () => {
          setLocationModel(true);
        }
      );
    };

    const checkNotificationPermission = async () => {
      if ("Notification" in window) {
        const isDismissed = secureLocalStorage.getItem("notification");
        if (Notification.permission !== "granted" && !isDismissed) {
          setNotificationError(true);
        }
      }
    };

    fetchLocation();
    checkNotificationPermission();
    handleInitOneSignal();
  }, []);

  useEffect(() => {
    if (!searchText || !type || searchText.trim().length < 3) {
      setSearchData([]);
      return;
    }

    const delayDebounce = setTimeout(async () => {
      try {
        setApiloading(type);
        const Response = await handleCallApi("Get", `customer/web_map_data?text=${searchText}`)
        if (Response.data.status === 'ERROR') {
          setShowToast(true);
          setToastMsg(Response.data.message || "Map key error");
          setSearchData([]);
        } else if (!Response.data.results || Response.data.results.length === 0) {
          setSearchData([]);
        } else {
          setSearchData(Response.data.results || []);
        }
        setApiloading("");
      } catch (error) {
        console.error(error);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [pickupLocation, dropLocation]);

  const handleFindRide = () => {

    if (!pickupLocation || !dropLocation) {
      setShowToast(true);
      setToastMsg("Please select pickup and drop location !!");
      return;
    }

    navigate("/find-ride", { state: navigateData });
  }

  const handleSelectLocation = (data) => {

    const locationAdd = {
      title: data.name,
      subt: data?.formatted_address || "",
    };

    const loactionLatLng = {
      latitude: data.geometry.location.lat,
      longitude: data.geometry.location.lng,
    }

    if (type === "Pickup") {
      setPickupLocation(data.formatted_address);
      setNavigateData(prev => ({
        ...prev,
        pick_add: locationAdd,
        pick_latlon: loactionLatLng
      }));
    } else {
      setDropLocation(data.formatted_address);
      setNavigateData(prev => ({
        ...prev,
        drop_add: locationAdd,
        drop_latlon: loactionLatLng
      }));
    }

    setSearchData([]);
    setType("");
  }

  const handleGetCurrentLocation = () => {
    if (!navigator.geolocation) {
      setShowToast(true);
      setToastMsg(t("Geolocation is not supported by your browser"));
      return;
    }

    setApiloading(type);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        try {
          const response = await handleCallApi(
            "Get",
            `customer/reverse_geocode?lat=${lat}&lng=${lng}`
          );

          if (response.data && response.data.results && response.data.results.length > 0) {
            const result = response.data.results[0];
            const placeData = {
              name: result.formatted_address.split(",")[0] || "Current Location",
              formatted_address: result.formatted_address,
              geometry: {
                location: {
                  lat: lat,
                  lng: lng,
                }
              }
            };
            handleSelectLocation(placeData);
          } else {
            setShowToast(true);
            setToastMsg(t("Could not fetch address for your location."));
          }
        } catch (err) {
          console.error("Error geocoding location:", err);
          setShowToast(true);
          setToastMsg(t("Error getting location address."));
        } finally {
          setApiloading("");
        }
      },
      (error) => {
        console.error("Geolocation error:", error);
        setShowToast(true);
        setToastMsg(t("Location permission denied or unavailable."));
        setApiloading("");
      }
    );
  };

  const handleCloseModel = () => {
    setSearchData([]);
    setType("");
    setPickupLocation("");
    setDropLocation("");
  }

  const handleInitOneSignal = async () => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid && !initialized.current) {
      await OneSignal.init({
        appId: "bb3fda7f-ec7e-44aa-9a05-45adfad78209",
        safari_web_id: "web.onesignal.auto.xxx",
        notifyButton: {
          enable: true,
        },
        serviceWorkerParam: { scope: "/" },
        serviceWorkerPath: "OneSignalSDKWorker.js",
        allowLocalhostAsSecureOrigin: true,
      }).then(async () => {
        OneSignal.User.addTags({
          "subscription_user_Type": "customer",
          "Login_ID": Userid,
        });
        initialized.current = true;
      }).catch((error) => {
        // console.error("OneSignal initialization error:", error);
      });
    }
  };

  return (
    <div className="overflow-hidden">

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          HERO SECTION â€” Original centered design with background image
         â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <div className="pb-4">
        <div className="image-section">
          <div className="w-full h-full width-container px-3 flex items-center justify-center z-20 relative">
            <div className="w-full text-center">

              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeOut", delay: 0.5 }}
                className="mb-4 text-4xl font-bold tracking-tight text-slate-900 md:text-6xl italic">{t("Your ride,")}
                <span className="text-[--bg-color] decoration-primary/30"> {t("your way")}</span>
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeOut", delay: 0.7 }}
                className="mb-12 text-lg text-slate-600">
                {t("Experience the next generation of urban mobility. Fast, reliable, and tailored")} <br /> {t("to your daily needs.")}
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, ease: "easeOut", delay: 0.9 }}
                className="max-w-[900px] mx-auto rounded-2xl bg-white p-6 shadow-2xl border border-slate-100 backdrop-blur-sm relative z-[999]">

                <div className="grid grid-cols-1 gap-4 md:grid-cols-12">
                  <div className="md:col-span-5 text-left">
                    <span className="text-xs font-bold uppercase tracking-wider text-slate-700">{t("Pickup Location")}</span>
                    <div className="w-full border px-[10px] flex items-center gap-2 mt-2 rounded-xl focus-within:ring-2 focus-within:ring-[--bg-color] transition-all">
                      <svg width="26" height="26" className="text-[--bg-color]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2.25C7.175 2.25 3.25 6.175 3.25 11C3.25 16.118 7.94699 19.2199 11.055 21.2729L11.584 21.624C11.71 21.708 11.855 21.75 12 21.75C12.145 21.75 12.29 21.708 12.416 21.624L12.945 21.2729C16.053 19.2199 20.75 16.118 20.75 11C20.75 6.175 16.825 2.25 12 2.25ZM12.119 20.021L12 20.1001L11.881 20.021C8.871 18.033 4.75 15.311 4.75 11C4.75 7.002 8.002 3.75 12 3.75C15.998 3.75 19.25 7.002 19.25 11C19.25 15.311 15.128 18.034 12.119 20.021ZM12 7.75C10.208 7.75 8.75 9.208 8.75 11C8.75 12.792 10.208 14.25 12 14.25C13.792 14.25 15.25 12.792 15.25 11C15.25 9.208 13.792 7.75 12 7.75ZM12 12.75C11.035 12.75 10.25 11.965 10.25 11C10.25 10.035 11.035 9.25 12 9.25C12.965 9.25 13.75 10.035 13.75 11C13.75 11.965 12.965 12.75 12 12.75Z" fill="currentColor" />
                      </svg>
                      <input type="text" value={pickupLocation} onChange={(e) => setPickupLocation(e.target.value)} onClick={() => setType("Pickup")} className="w-full py-3 outline-none text-[17px]" placeholder={t("Where from?")} />
                      {pickupLocation && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setPickupLocation("");
                            setSearchData([]);
                          }}
                          className="text-gray-400 hover:text-gray-600 p-1"
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </button>
                      )}
                      {apiLoading === "Pickup" && <span className='loader max-w-4 min-w-4 h-4'></span>}
                    </div>
                  </div>

                  <div className="md:col-span-5 text-left">
                    <span className="text-xs font-bold uppercase tracking-wider text-slate-700">{t("Drop-off Location")}</span>
                    <div className="w-full border px-[10px] flex items-center gap-2 mt-2 rounded-xl focus-within:ring-2 focus-within:ring-[--bg-color] transition-all">
                      <svg width="26" height="26" className="text-[--bg-color]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.469 21.75C12.419 21.75 12.368 21.7479 12.317 21.7439C11.552 21.6819 10.922 21.165 10.711 20.428L9.62098 16.6121C9.30998 15.5251 8.47599 14.6909 7.38899 14.3799L3.57301 13.2901C2.83501 13.0791 2.31903 12.4491 2.25703 11.6841C2.19503 10.9191 2.60398 10.214 3.29798 9.88699L19.148 2.42899C19.851 2.09699 20.663 2.23907 21.213 2.79007C21.764 3.34007 21.905 4.15101 21.574 4.85501L14.116 20.7051C13.809 21.3511 13.174 21.75 12.469 21.75ZM19.785 3.78494L3.93501 11.243C3.75901 11.326 3.74401 11.478 3.75001 11.562C3.75601 11.646 3.79598 11.793 3.98298 11.847L7.79902 12.937C9.38802 13.391 10.608 14.61 11.061 16.199L12.151 20.0149C12.205 20.2029 12.352 20.2421 12.436 20.2481C12.52 20.2491 12.672 20.24 12.755 20.063L20.213 4.21292C20.297 4.03392 20.209 3.90696 20.149 3.84696C20.092 3.78896 19.963 3.69994 19.785 3.78494Z" fill="currentColor" />
                      </svg>
                      <input type="text" value={dropLocation} onChange={(e) => setDropLocation(e.target.value)} onClick={() => setType("Drop")} className="w-full py-3 outline-none text-[17px]" placeholder={t("Where to?")} />
                      {dropLocation && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setDropLocation("");
                            setSearchData([]);
                          }}
                          className="text-gray-400 hover:text-gray-600 p-1"
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </button>
                      )}
                      {apiLoading === "Drop" && <span className='loader max-w-4 min-w-4 h-4'></span>}
                    </div>
                  </div>

                  <div className="md:col-span-2 flex items-end">
                    <button onClick={handleFindRide} className="h-14 w-full rounded-xl bg-[--bg-color] italic text-base font-bold text-white shadow-lg shadow-primary/20 hover:scale-[1.02] transition-transform active:scale-95">
                      {t("Find Ride")}
                    </button>
                  </div>

                </div>

                {type !== "" && <div className="w-full max-h-[500px] overflow-y-auto scroll-container absolute left-0 top-[140px] shadow-[0_0_10px_0] shadow-black/20 bg-white py-[10px] rounded-2xl z-[9999]">
                  {/* Allow Location Access Option */}
                  <div onClick={handleGetCurrentLocation} className="mt-1 px-[20px] py-3 hover:bg-gray-100 cursor-pointer flex items-center gap-3">
                    <div className="max-w-[40px] min-w-[40px] h-[40px] bg-black rounded-full flex items-center justify-center text-white">
                      <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" fill="currentColor"/>
                        <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2"/>
                        <line x1="12" y1="2" x2="12" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <line x1="12" y1="20" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <line x1="2" y1="12" x2="4" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <line x1="20" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <div className="text-start leading-5">
                      <h1 className='font-semibold text-slate-900'>{t("Allow location access")}</h1>
                      <p className='text-[14px] text-blue-500'>{t("It provides your pickup address")}</p>
                    </div>
                  </div>

                  {searchText.trim().length === 0 ? (
                    <>
                      {(() => {
                        const rawRecents = localStorage.getItem("recent_searches");
                        const recents = rawRecents ? JSON.parse(rawRecents) : [];
                        if (recents.length === 0) return null;
                        return (
                          <div>
                            <h3 className="px-5 pt-3 pb-1 text-xs font-bold text-gray-400 uppercase tracking-wider text-start">{t("Recent Searches")}</h3>
                            {recents.map((item, idx) => (
                              <div
                                key={`recent-${idx}`}
                                className="px-5 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-between group"
                              >
                                <div
                                  onClick={() => {
                                    const placeData = {
                                      name: item.title,
                                      formatted_address: item.subt,
                                      geometry: {
                                        location: {
                                          lat: item.lat,
                                          lng: item.lng
                                        }
                                      }
                                    };
                                    handleSelectLocation(placeData);
                                  }}
                                  className="flex items-center gap-3 flex-grow text-start min-w-0"
                                >
                                  <div className="max-w-[40px] min-w-[40px] h-[40px] bg-gray-200 rounded-full flex items-center text-gray-600 justify-center">
                                    <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                  </div>
                                  <div className="flex flex-col justify-center flex-grow min-w-0">
                                    <h1 className="font-semibold text-gray-700 text-sm leading-tight truncate">{item.title}</h1>
                                    <p className="text-xs text-gray-500 line-clamp-1 mt-1 truncate">{item.subt}</p>
                                  </div>
                                </div>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const rawRecents = localStorage.getItem("recent_searches");
                                    let recentsList = rawRecents ? JSON.parse(rawRecents) : [];
                                    recentsList = recentsList.filter(r => r.title !== item.title || r.subt !== item.subt);
                                    localStorage.setItem("recent_searches", JSON.stringify(recentsList));
                                    setRecentUpdateTrigger(prev => prev + 1);
                                  }}
                                  className="text-gray-400 hover:text-red-500 p-2 ml-2 flex-shrink-0"
                                  title={t("Delete")}
                                >
                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </button>
                              </div>
                            ))}
                          </div>
                        );
                      })()}
                    </>
                  ) : (
                    searchData.map((item, index) => {
                      return <div key={index} onClick={() => handleSelectLocation(item)} className="mt-1 px-[20px] py-3 hover:bg-gray-100 cursor-pointer flex items-center gap-3">
                        <div className="max-w-[40px] min-w-[40px] h-[40px] bg-gray-200 rounded-full flex items-center text-black justify-center">
                          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                            <path d="M18.7 3.8C15 .1 9 .1 5.3 3.8c-3.7 3.7-3.7 9.8 0 13.5L12 24l6.7-6.8c3.7-3.6 3.7-9.7 0-13.4ZM12 12.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z" fill="currentColor"></path>
                          </svg>
                        </div>
                        <div className="text-start leading-5">
                          <h1 className='font-semibold text-gray-900'>{item.name}</h1>
                          <p className='text-[15px] line-clamp-2'>{item.formatted_address}</p>
                        </div>
                      </div>
                    })
                  )}
                </div>}


              </motion.div>

              {type !== "" && <div onClick={handleCloseModel} className="w-full h-[100vh] left-0 top-0 fixed z-[444]"></div>}
            </div>
          </div>
        </div>
      </div>

      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          SERVICES SECTION â€” Horizontal cards, warm gray bg
         â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <section className="bg-gray-50 py-16 sm:py-20">
        <div className="width-container px-4 sm:px-6">

          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-[--bg-color] text-sm font-bold uppercase tracking-widest">{t("What We Offer")}</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-2">{t("Our Services")}</h2>
            <p className="text-slate-500 mt-3 max-w-lg mx-auto">{t("From daily commute to outstation trips, we've got you covered with reliable options.")}</p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((item, index) => {
              const Title = item.name.replace(/\s+/g, '-').toLowerCase();
              const Path = (item.name === "Bike" || item.name === "Auto" || item.name === "Taxi") ? "/find-ride" : `/${Title}`;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 25 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.08 }}
                  onClick={() => navigate(Path, { state: item.role })}
                  className="group bg-white rounded-2xl p-5 flex items-center gap-5 cursor-pointer border border-slate-100 hover:border-[#4038ff]/20 hover:shadow-lg hover:shadow-[#4038ff]/[0.06] transition-all duration-300"
                >
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg font-bold text-slate-900 mb-1 group-hover:text-[--bg-color] transition-colors">{item.name}</h3>
                    <p className="text-sm text-slate-500 leading-relaxed line-clamp-2 mb-3">{item.description}</p>
                    <span className="inline-flex items-center text-sm font-semibold text-[--bg-color] gap-1 group-hover:gap-2.5 transition-all duration-300">
                      {t("Book now")}
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                      </svg>
                    </span>
                  </div>
                  <div className="w-20 h-20 rounded-xl bg-slate-50 group-hover:bg-[#4038ff]/[0.06] overflow-hidden flex items-center justify-center flex-shrink-0 transition-colors duration-300">
                    <ImageLoad src={BaseUrl + item.image} CustomeStyle={"w-full h-full"} ImagStyle={"w-full h-full object-contain p-2"} alt={`${item.name}`} status={false} />
                  </div>
                </motion.div>
              );
            })}
          </div>

        </div>
      </section>


      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          HOW IT WORKS â€” Horizontal stepper/timeline
         â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <section className="bg-white py-16 sm:py-20">
        <div className="width-container px-4 sm:px-6">

          <motion.div
            className="text-center mb-14"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-[--bg-color] text-sm font-bold uppercase tracking-widest">{t("Simple Process")}</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-2">{t("How It Works")}</h2>
            <p className="text-slate-500 mt-3 max-w-lg mx-auto">{t("Get moving in just four easy steps. It's that simple.")}</p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-0 relative">
            {/* Connecting line for desktop */}
            <div className="hidden lg:block absolute top-[34px] left-[12.5%] right-[12.5%] h-[2px] bg-slate-200" />

            {howItWorks.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.12 }}
                className="flex flex-col items-center text-center relative px-4"
              >
                {/* Step circle */}
                <div className="relative z-10 mb-5">
                  <div className="w-[68px] h-[68px] rounded-full bg-[#4038ff]/[0.08] flex items-center justify-center border-2 border-[#4038ff]/20">
                    <div className="w-11 h-11 rounded-full bg-[--bg-color] text-white flex items-center justify-center shadow-lg shadow-[#4038ff]/25">
                      {item.icon}
                    </div>
                  </div>
                  {/* Step number badge */}
                  <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-slate-900 text-white text-[11px] font-bold flex items-center justify-center">{index + 1}</span>
                </div>

                <h3 className="text-lg font-bold text-slate-900 mb-2">{t(item.title)}</h3>
                <p className="text-sm text-slate-500 leading-relaxed max-w-[220px]">{t(item.desc)}</p>
              </motion.div>
            ))}
          </div>

        </div>
      </section>


      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          FEATURES / WHY CHOOSE US â€” Dark section
         â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <section className="bg-slate-900 py-16 sm:py-20 relative overflow-hidden">
        {/* Subtle glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#4038ff]/[0.08] blur-[120px] pointer-events-none" />

        <div className="width-container px-4 sm:px-6 relative z-10">

          <motion.div
            className="text-center mb-14"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-[#4038ff] text-sm font-bold uppercase tracking-widest">{t("Why ") + siteTitle}</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white mt-2">{t("Built for riders who deserve better")}</h2>
            <p className="text-slate-400 mt-3 max-w-lg mx-auto">{t("Safety, speed, and savings â€” all in one app.")}</p>
          </motion.div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {features.map((item, index) => (
              <motion.div key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex flex-col items-center text-center p-8 rounded-2xl bg-white/[0.04] border border-white/[0.06] hover:border-[#4038ff]/30 hover:bg-white/[0.07] transition-all duration-300 group"
              >
                <div className="w-14 h-14 rounded-xl bg-[#4038ff]/15 text-[#4038ff] flex items-center justify-center mb-5 group-hover:shadow-[0_0_30px_rgba(64,56,255,0.3)] group-hover:bg-[#4038ff]/25 transition-all duration-300">
                  {item.icon}
                </div>

                <h3 className="font-bold text-[1.05rem] text-white mb-2">
                  {t(item.title)}
                </h3>

                <p className="text-sm text-slate-400 leading-relaxed max-w-[220px]">
                  {t(item.desc)}
                </p>
              </motion.div>
            ))}
          </div>

        </div>
      </section>


      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          CTA BANNER â€” Before footer
         â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <section className="bg-[--bg-color] relative overflow-hidden">
        {/* Decorative shapes */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute -top-20 -left-20 w-60 h-60 rounded-full bg-white/[0.06]" />
          <div className="absolute -bottom-10 -right-10 w-40 h-40 rounded-full bg-white/[0.04]" />
          <div className="absolute top-10 right-1/4 w-20 h-20 rounded-full bg-white/[0.03]" />
        </div>

        <div className="width-container px-4 sm:px-6 py-14 sm:py-16 relative z-10">
          <motion.div
            className="flex flex-col sm:flex-row items-center justify-between gap-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="text-center sm:text-left">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-2">{t("Ready to ride?")}</h2>
              <p className="text-white/70 text-base sm:text-lg">{t("Download the app or book a ride now. Your next trip is just a tap away.")}</p>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 flex-shrink-0">
              <button
                onClick={() => navigate("/find-ride")}
                className="w-full sm:w-auto px-8 py-3.5 bg-white text-[--bg-color] font-bold rounded-xl hover:bg-slate-50 active:scale-95 transition-all duration-200 shadow-lg shadow-black/10 text-[15px]"
              >
                {t("Book a Ride")}
              </button>
              <button
                onClick={() => window.open("https://play.google.com/store", "_blank")}
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 text-white font-bold rounded-xl border border-white/20 hover:bg-white/20 active:scale-95 transition-all duration-200 text-[15px] backdrop-blur-sm"
              >
                {t("Download App")}
              </button>
            </div>
          </motion.div>
        </div>
      </section>


      {/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
          MODALS â€” Location & Notification (preserved exactly)
         â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <AnimatePresence initial={false}>
        {locationModel && <div style={{ zIndex: "100000" }} className="model items-center">
          <motion.div
            key="content"
            initial="close"
            animate="open"
            exit="close"
            variants={{
              open: { opacity: 1, y: 0 },
              close: { opacity: 0, y: 30 },
            }}
            transition={{ duration: 0.3 }}
            className="bg-white w-[450px] p-[20px] rounded-[20px] relative mx-3"
          >

            <Lottie
              className="w-[300px] mx-auto mb-[20px]"
              animationData={LoginLottie}
              loop={true}
            />

            <div className="text-center my-5">
              <h1 className="font-bold text-[18px] text-gray-800">{t("Location permission not enabled")}</h1>
              <p className="text-gray-600 leading-5">{t("Sharing Location permission helps us improve your ride booking and pickup experience.")}</p>
            </div>

            <button onClick={() => setLocationModel(false)} className="w-full bg-[--bg-color] font-medium italic text-white py-2 rounded-[10px]">{t("Allow Permission")}</button>

          </motion.div>
        </div>}
      </AnimatePresence>

      <AnimatePresence initial={false}>
        {notificationerror && <div className="model items-center">
          <motion.div
            key="content"
            initial="close"
            animate="open"
            exit="close"
            variants={{
              open: { opacity: 1, y: 0 },
              close: { opacity: 0, y: 30 },
            }}
            transition={{ duration: 0.3 }}
            className="bg-white w-[450px] p-[20px] rounded-[20px] relative mx-3"
          >

            <div>

              <div>
                <img src={NotificationError} className="w-[200px] mx-auto" alt="NotificationError" />
                <h1 className="text-center font-bold text-[18px] text-gray-800 mt-2">{t("Allow Notification and on-ride alerts")}</h1>
              </div>

              <div className="mt-5 flex items-center gap-3">
                <img src={MapPin} alt="Location map pin" />
                <div>
                  <h1 className="font-medium">{t("Real-time Captain updates")}</h1>
                  <p className="leading-5 text-gray-600 text-[15px]">{t("Get notified about captain's allocation,")} <br /> {t("arrival and more")}</p>
                </div>
              </div>

              <div className="mt-5 flex items-center gap-3">
                <img src={TrafficLight} alt="TrafficLight" />
                <div>
                  <h1 className="font-medium">{t("Offer and news")}</h1>
                  <p className="leading-5 text-gray-600 text-[15px]">{t("Be the first to konw about our offers")} <br /> {t("and new features")}</p>
                </div>
              </div>

            </div>

            <button onClick={async () => {
              secureLocalStorage.setItem("notification", true);
              if ("Notification" in window) {
                if (Notification.permission === "default") {
                  setNotificationError(false);
                  try {
                    await Notification.requestPermission();
                  } catch (e) {}
                } else if (Notification.permission === "denied") {
                  alert(t("Notifications are blocked in your browser settings. Please click the lock or settings icon next to the URL in your browser address bar to allow notifications for this site."));
                  setNotificationError(false);
                } else {
                  setNotificationError(false);
                }
              } else {
                setNotificationError(false);
              }
            }} className="w-full mt-5 bg-[--bg-color] font-medium italic text-white py-2 rounded-[10px]">{t("Allow")}</button>
            <button onClick={() => { setNotificationError(false); secureLocalStorage.setItem("notification", true); }} className="w-full mt-2 border border-black text-black py-2 italic font-medium rounded-[10px]">{t("Maybe, later")}</button>

          </motion.div>
        </div>}
      </AnimatePresence>

      <PageLoader loading={loading} />

    </div >
  )
}

export default Home
